import React from 'react';
import { Gauge, Waves, Crosshair } from 'lucide-react';
import { motion } from 'framer-motion';
import { barColor } from '../../lib/api';
import { useLanguage } from '../../i18n';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const METRICS = [
  { key: 'execution_speed', icon: Gauge, labelKey: 'executionSpeed' },
  { key: 'movement_fluidity', icon: Waves, labelKey: 'movementFluidity' },
  { key: 'center_of_gravity', icon: Crosshair, labelKey: 'centerOfGravity' },
];

export const MetricAccordions = ({ report }) => {
  const { t, lang } = useLanguage();

  return (
    <Accordion type="multiple" defaultValue={['execution_speed']} className="space-y-2.5" data-testid="result-metrics-accordion">
      {METRICS.map(({ key, icon: Icon, labelKey }) => {
        const metric = report.metrics[key];
        const color = barColor(metric.score);
        return (
          <AccordionItem key={key} value={key} className="ss-card border-white/[0.08] rounded-[16px] px-4 border-b-0">
            <AccordionTrigger className="hover:no-underline py-3.5" data-testid={`result-metric-trigger-${key}`}>
              <div className="flex items-center gap-3 flex-1 mr-2">
                <span className="w-9 h-9 rounded-[14px] bg-white/[0.04] border border-white/10 flex items-center justify-center shrink-0">
                  <Icon size={16} style={{ color }} />
                </span>
                <span className="text-sm font-medium flex-1 text-left text-white/90">{t(labelKey)}</span>
                <span className="font-display font-bold tabular-nums text-lg" style={{ color }} data-testid={`result-metric-score-${key}`}>
                  {metric.score}
                  <span className="text-[10px] text-white/40 font-mono">/100</span>
                </span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="pb-4">
              <div className="h-1.5 rounded-full bg-white/[0.06] overflow-hidden mb-3">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${metric.score}%` }}
                  transition={{ duration: 0.7, ease: 'easeOut' }}
                  className="h-full rounded-full"
                  style={{ background: color, boxShadow: `0 0 12px ${color}55` }}
                />
              </div>
              <p className="text-sm text-white/75 leading-relaxed" data-testid={`result-metric-feedback-${key}`}>
                {lang === 'it' ? metric.feedback_it : metric.feedback_en}
              </p>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
